import { FieldValidatorWithComingSoon } from '@/components/ui';
import {
  VALIDATOR_BIC_SWIFT_FUNCTION_ID,
  VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID,
  VALIDATOR_CONFIDENCE_FUNCTION_ID,
  VALIDATOR_CUSTOM_CODE_FUNCTION_ID,
  VALIDATOR_DATABASE_MATCH_FUNCTION_ID,
  VALIDATOR_EMAIL_FUNCTION_ID,
  VALIDATOR_FREIGHT_CONTAINER_ID_FUNCTION_ID,
  VALIDATOR_IBAN_FUNCTION_ID,
  VALIDATOR_LICENSE_PLATE_FUNCTION_ID,
  VALIDATOR_LOGEX_FUNCTION_ID,
  VALIDATOR_PASSPORT_NUMBER_FUNCTION_ID,
  VALIDATOR_PHONE_NUMBER_FUNCTION_ID,
  VALIDATOR_REGEX_FUNCTION_ID,
  VALIDATOR_TAX_ID_FUNCTION_ID,
  VALIDATOR_URL_FUNCTION_ID,
  VALIDATOR_VAT_ID_FUNCTION_ID,
} from '@/constants';

const VALIDATOR_CANNOT_BE_EMPTY: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID,
  name: 'Cannot be empty',
  description: 'Check that field has value(s)',
  config: {},
};

const VALIDATOR_CONFIDENCE: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_CONFIDENCE_FUNCTION_ID,
  name: 'Confidence threshold',
  description: 'Check that field has confidence above threshold',
  config: { thresholds: { automate: 0.9 } },
};

const VALIDATOR_LOGEX: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_LOGEX_FUNCTION_ID,
  name: 'Logical expression',
  description: 'Simple arithmetic and/or logical operations',
  config: {},
};

const VALIDATOR_REGEX: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_REGEX_FUNCTION_ID,
  name: 'RegExp',
  description: 'String match with RegExp',
  config: { matchFlags: 'gs' },
};

const VALIDATOR_DATABASE_MATCH: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_DATABASE_MATCH_FUNCTION_ID,
  name: 'Database match',
  description: 'Verify that value exists in database',
  config: {},
  comingSoon: true,
};

const VALIDATOR_CUSTOM_CODE: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_CUSTOM_CODE_FUNCTION_ID,
  name: 'Custom JS',
  description: 'Write your own JS validator',
  config: {},
  comingSoon: true,
};

const VALIDATOR_IBAN: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_IBAN_FUNCTION_ID,
  name: 'IBAN',
  description: 'International Bank Account Number validation',
  config: {},
};

const VALIDATOR_VAT_ID: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_VAT_ID_FUNCTION_ID,
  name: 'VAT ID',
  description: 'Value Added Tax Identification Number validation',
  config: {},
};

const VALIDATOR_TAX_ID: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_TAX_ID_FUNCTION_ID,
  name: 'Tax ID',
  description: 'Tax Identification Number validation',
  config: {},
};

const VALIDATOR_PASSPORT_NUMBER: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_PASSPORT_NUMBER_FUNCTION_ID,
  name: 'Passport Number',
  description: 'Passport number validation',
  config: {},
};

const VALIDATOR_LICENSE_PLATE: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_LICENSE_PLATE_FUNCTION_ID,
  name: 'License Plate',
  description: 'Vehicle license plate validation',
  config: {},
};

const VALIDATOR_PHONE_NUMBER: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_PHONE_NUMBER_FUNCTION_ID,
  name: 'Phone Number',
  description: 'Phone number validation',
  config: {},
};

const VALIDATOR_EMAIL: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_EMAIL_FUNCTION_ID,
  name: 'Email',
  description: 'Email address validation',
  config: {},
};

const VALIDATOR_BIC_SWIFT: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_BIC_SWIFT_FUNCTION_ID,
  name: 'BIC/SWIFT',
  description: 'Bank Identifier Code/Society for Worldwide Interbank Financial Telecommunication validation',
  config: {},
};

const VALIDATOR_FREIGHT_CONTAINER_ID: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_FREIGHT_CONTAINER_ID_FUNCTION_ID,
  name: 'Freight Container ID',
  description: 'Freight container identification code validation',
  config: {},
};

const VALIDATOR_URL: FieldValidatorWithComingSoon = {
  functionId: VALIDATOR_URL_FUNCTION_ID,
  name: 'URL',
  description: 'Web address validation',
  config: {},
};

const POPULAR_VALIDATORS = [VALIDATOR_CONFIDENCE, VALIDATOR_LOGEX, VALIDATOR_REGEX, VALIDATOR_CANNOT_BE_EMPTY];
const STRING_VALIDATORS = [
  VALIDATOR_REGEX,
  VALIDATOR_DATABASE_MATCH,
  VALIDATOR_CANNOT_BE_EMPTY,
  VALIDATOR_URL,
  VALIDATOR_EMAIL,
];
const DATE_TIME_VALIDATORS = [VALIDATOR_LOGEX];
const NUMBER_VALIDATORS = [
  VALIDATOR_CONFIDENCE,
  VALIDATOR_IBAN,
  VALIDATOR_VAT_ID,
  VALIDATOR_TAX_ID,
  VALIDATOR_PASSPORT_NUMBER,
  VALIDATOR_LICENSE_PLATE,
  VALIDATOR_PHONE_NUMBER,
  VALIDATOR_BIC_SWIFT,
  VALIDATOR_FREIGHT_CONTAINER_ID,
];
const CUSTOM_VALIDATORS = [VALIDATOR_CUSTOM_CODE];

export type ValidatorsType = Record<string, FieldValidatorWithComingSoon[]>;
export const DEFAULT_VALIDATOR_CATEGORY = 'Popular';
export const VALIDATORS: ValidatorsType = {
  [DEFAULT_VALIDATOR_CATEGORY]: POPULAR_VALIDATORS,
  Strings: STRING_VALIDATORS,
  Numbers: NUMBER_VALIDATORS,
  'Date & time': DATE_TIME_VALIDATORS,
  Custom: CUSTOM_VALIDATORS,
};
